export function obterListaCteModeloNfOutros() {
  return (
    [
      { label: 'Nenhuma', value: '' },
      { label: '00 - Declaração', value: '00' },
      { label: '10 - Dutoviário', value: '10' },
      { label: '59 - CF-e SAT', value: '59' },
      { label: '65 - NFC-e', value: '65' },
      { label: '99 - Outros', value: '99'},
    ]
  );
}
